import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPowerManagement = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 13.5C3.44771 13.5 3 13.0523 3 12.5C3 7.25329 7.25329 3 12.5 3C17.7467 3 22 7.25329 22 12.5C22 17.7467 17.7467 22 12.5 22C11.9477 22 11.5 21.5523 11.5 21C11.5 20.4477 11.9477 20 12.5 20C16.6421 20 20 16.6421 20 12.5C20 8.35786 16.6421 5 12.5 5C8.35786 5 5 8.35786 5 12.5C5 13.0523 4.55228 13.5 4 13.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.2421 7.29015C13.5697 7.40187 13.7782 7.72323 13.7469 8.0679L13.5031 10.75H14.5C14.7737 10.75 15.0257 10.8991 15.1575 11.1391C15.2892 11.3791 15.2797 11.6717 15.1327 11.9027L11.6327 17.4027C11.4469 17.6946 11.0855 17.8216 10.7579 17.7098C10.4303 17.5981 10.2217 17.2768 10.2531 16.9321L10.4969 14.25H9.5C9.22626 14.25 8.97427 14.1009 8.84254 13.8609C8.71082 13.6209 8.72029 13.3283 8.86725 13.0973L12.3672 7.59734C12.5531 7.30536 12.9145 7.17843 13.2421 7.29015ZM10.8663 12.75H11.3182C11.5289 12.75 11.7299 12.8386 11.872 12.9942C12.0141 13.1498 12.0842 13.358 12.0651 13.5679L12.0268 13.9895L13.1337 12.25H12.6818C12.4711 12.25 12.2701 12.1614 12.128 12.0058C11.9859 11.8502 11.9158 11.642 11.9349 11.4321L11.9732 11.0105L10.8663 12.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.25 14C1.25 13.0335 2.0335 12.25 3 12.25H5C5.9665 12.25 6.75 13.0335 6.75 14V15C6.75 15.4142 6.41421 15.75 6 15.75H2C1.58579 15.75 1.25 15.4142 1.25 15V14ZM3 13.75C2.86193 13.75 2.75 13.8619 2.75 14V14.25H5.25V14C5.25 13.8619 5.13807 13.75 5 13.75H3Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.25711 14.2773C5.67132 14.2773 6.00711 14.6131 6.00711 15.0273V16.5273C6.00711 16.9416 5.67132 17.2773 5.25711 17.2773C4.8429 17.2773 4.50711 16.9416 4.50711 16.5273V15.0273C4.50711 14.6131 4.8429 14.2773 5.25711 14.2773Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.76004 14.25C3.17425 14.25 3.51004 14.5858 3.51004 15V16.5C3.51004 16.9142 3.17425 17.25 2.76004 17.25C2.34583 17.25 2.01004 16.9142 2.01004 16.5V15C2.01004 14.5858 2.34583 14.25 2.76004 14.25Z",
			fill: "currentColor"
		})
	]
});
export default SvgPowerManagement;
